
import * as React from 'react';
import { useTranslation } from "react-i18next";
import "../../../Localization/i18n";

import { styled } from '@mui/system';
import TabsUnstyled from '@mui/base/TabsUnstyled';
import TabsListUnstyled from '@mui/base/TabsListUnstyled';
import TabPanelUnstyled from '@mui/base/TabPanelUnstyled';
import { buttonUnstyledClasses } from '@mui/base/ButtonUnstyled';
import TabUnstyled, { tabUnstyledClasses } from '@mui/base/TabUnstyled';
import SetupNotifications from './SetupNotifications/SetupNotifications';
import SetupInvitationReminders from './SetupInvitationReminders/SetupInvitationReminders';
import InvitationConfiguration from './InvitationConfiguration';
import InvitationCCSetup from './InvitationCCSetup';
import NotificationsCCSetup from './NotificationsCCSetup';
import NotificationsSetup from './NotificationsSetup/NotificationsSetup';
import { useLocation } from 'react-router-dom';
import { useGlobalComponent } from '../../../pages/commom/GlobalComponentProvider';
import { useEffect, useState } from 'react';
import { HasScreenPermissions } from '../../../utils/Token';
import INFO from '../../../pages/commom/RouteUrlInfo.json';

const white = {
  50: '#fff',
  100: '#fff',
  200: '#fff',
  300: '#fff',
  400: '#fff',
  500: '#F2F4F7',
  600: '#030202',
  700: '#0059B2',
  800: '#fff',
  900: '#fff',
};

const Tab = styled(TabUnstyled)`
  font-family: IBM Plex Sans, sans-serif;
  color: black;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: bold;
  background-color: transparent;
  width: 100%;
  padding: 10px 5px;
  margin: 6px 6px;
  border: none;
  border-radius: 5px;
  display: flex;
  justify-content: center;

  &:hover {
    background-color: ${white[400]};
  }

  &:focus {
    color: #fff;
    border-radius: 3px;
    outline: 2px solid ${white[200]};
    outline-offset: 2px;
  }

  &.${tabUnstyledClasses.selected} {
    background-color: ${white[50]};
    color: ${white[600]};
  }

  &.${buttonUnstyledClasses.disabled} {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const TabPanel = styled(TabPanelUnstyled)`
  width: 100%;
  font-family: IBM Plex Sans, sans-serif;
  font-size: 0.875rem;
`;

const TabsList = styled(TabsListUnstyled)`
  min-width: 1020px;
  background-color: ${white[500]};
  border-radius: 8px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: space-between;
`;


export default function NotificationsAndInvitationsTab() {
  const { t } = useTranslation();
  const { currentActiveTab, currentActiveSubTab } = useGlobalComponent();

  const [value, setValue] = useState(0);
  const location = useLocation();
  const findFirstAccessibleTab = () => {
    // if (!HasScreenPermissions(INFO?.ManageNotifications?.actionName)) return 0;
    // if (!HasScreenPermissions(INFO?.ManageInvitationNotifications?.actionName)) return 1;
    // if (!HasScreenPermissions(INFO?.AddInvitationTemplates?.actionName)) return 2;
    // if (!HasScreenPermissions(INFO?.AddInviteNotifications?.actionName)) return 3;
    // if (!HasScreenPermissions(INFO?.CronjobNotificationSetup?.actionName)) return 4;
    // if (!HasScreenPermissions(INFO?.NotificationsSetup?.actionName)) return 5;
    // return -1; // If no tabs are accessible
    if (location?.pathname.slice(1) == INFO?.ManageNotifications?.actionName) {
      return 0;
    } else if (location?.pathname.slice(1) == INFO?.ManageInvitationNotifications?.actionName) {
      return 1;
    } else if (location?.pathname.slice(1) == INFO?.AddInvitationTemplates?.actionName) {
      return 2;
    } else if (location?.pathname.slice(1) == INFO?.AddInviteNotifications?.actionName) {
      return 3;
    } else if (location?.pathname.slice(1) == INFO?.CronjobNotificationSetup?.actionName) {
      return 4;
    } else if (location?.pathname.slice(1) == INFO?.NotificationsSetup?.actionName) {
      return 5;
    } else {
      return 0;
    }
  };

  useEffect(() => {
    setValue(currentActiveSubTab);
  }, [currentActiveSubTab, location]);

  // Update the active tab when permissions or location change
  useEffect(() => {
    const firstAccessibleTab = findFirstAccessibleTab();
    setValue(firstAccessibleTab);
  }, [INFO, location]);


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (

    <>
      <div className="row" >
        <TabsUnstyled value={value} onChange={handleChange} sx={{ backgroundColor: "#fff" }}>
          <TabsList sx={{ width: "Auto" }}>
            <Tab hidden={HasScreenPermissions(INFO?.ManageNotifications?.actionName)}> Setup Notifications</Tab>
            <Tab hidden={HasScreenPermissions(INFO?.ManageInvitationNotifications?.actionName)}> Setup Invitation Reminders</Tab>
            <Tab hidden={HasScreenPermissions(INFO?.AddInvitationTemplates?.actionName)}> Invitation Configuration</Tab>
            <Tab hidden={HasScreenPermissions(INFO?.AddInviteNotifications?.actionName)}> Invitation CC Setup</Tab>
            <Tab hidden={HasScreenPermissions(INFO?.CronjobNotificationSetup?.actionName)}> Notifications CC Setup</Tab>
            <Tab hidden={HasScreenPermissions(INFO?.NotificationsSetup?.actionName)}> Notifications Setup</Tab>
          </TabsList>
          <TabPanel value={0} hidden={HasScreenPermissions(INFO?.ManageNotifications?.actionName)}><SetupNotifications /></TabPanel>
          <TabPanel value={1} hidden={HasScreenPermissions(INFO?.ManageInvitationNotifications?.actionName)}><SetupInvitationReminders /></TabPanel>
          <TabPanel value={2} hidden={HasScreenPermissions(INFO?.AddInvitationTemplates?.actionName)}><InvitationConfiguration /></TabPanel>
          <TabPanel value={3} hidden={HasScreenPermissions(INFO?.AddInviteNotifications?.actionName)}><InvitationCCSetup /></TabPanel>
          <TabPanel value={4} hidden={HasScreenPermissions(INFO?.CronjobNotificationSetup?.actionName)}><NotificationsCCSetup /></TabPanel>
          <TabPanel value={5} hidden={HasScreenPermissions(INFO?.NotificationsSetup?.actionName)}><NotificationsSetup /></TabPanel>
        </TabsUnstyled>

      </div>

    </>
  );
}

